module.exports = __webpack_public_path__ + "media/images/front/img_ad_receipt-5d679235b09eac1b6586e92c30b5cda1.jpg";